declare let transKeys

export const getTrans = key => {
    if (
        typeof transKeys != 'undefined' &&
        typeof transKeys[key] != 'undefined'
    ) {
        return transKeys[key]
    } else {
        return key
    }
}
